export default __webpack_public_path__ + "static/media/check.64eb503c.svg";